import React from "react";
import { Text, TouchableOpacity, StyleSheet, Platform } from "react-native";

export default function AutocompleteOption(props) {
  const { onOptionPress, option } = props;

  const handlePress = () => {
    onOptionPress(option);
  };

  return (
    <TouchableOpacity onPress={handlePress}>
      <Text style={styles.autocompleteOptionText}>{option.name}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  autocompleteOptionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "#8B92A1", 
    padding: 5,
  },
});
